import { format, isToday, isYesterday } from 'date-fns'

import { EMPTY_STRING } from '../../../constants/common'
import { DATE_SHORT_FORMAT, TIME_INPUT_FORMAT } from '../../../constants/date'
import { toUkTimezoneDate } from '../../../utils/date'

export function getChatroomMessageEditedTooltipText({ editedAt, t, timeZone }) {
  if (!editedAt) {
    return EMPTY_STRING
  }

  const dateValue = new Date(editedAt)

  if (Number.isNaN(dateValue.getTime())) {
    return EMPTY_STRING
  }

  const ukDate = toUkTimezoneDate(dateValue, timeZone)
  const time = format(ukDate, TIME_INPUT_FORMAT)

  if (isToday(ukDate)) {
    return t('Chatroom.MessageEditedTodayTooltipKey', { time })
  }

  if (isYesterday(ukDate)) {
    return t('Chatroom.MessageEditedYesterdayTooltipKey', { time })
  }

  return t('Chatroom.MessageEditedDateTooltipKey', {
    date: format(ukDate, DATE_SHORT_FORMAT),
    time,
  })
}
